import {Component, Input, OnInit} from '@angular/core';
import {ColDef, ColumnApi, GridApi, GridReadyEvent} from 'ag-grid-community';
import {Gefahrgut} from '../../models/gefahrgutModel';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';
import {AG_GRID_LOCALE_DE} from '../../locale.de';

@Component({
  selector: 'lib-dangerous-goods',
  templateUrl: './dangerous-goods.component.html',
  styleUrls: ['./dangerous-goods.component.css']
})
export class DangerousGoodsComponent implements OnInit {

  public gridApi: GridApi;
  public gridColumnApi: ColumnApi;
  public columnDef: ColDef[];
  public defaultColDef: ColDef;

  public carretUp = faCaretUp;
  public carretDown = faCaretDown;
  public show: boolean;

  public isCollapsed: boolean = false;

  public locale = AG_GRID_LOCALE_DE;

  @Input() dangerous_goods: Gefahrgut[];


  constructor() {
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      flex: 1,
      lockPosition: true,
      cellClass: 'locked-col'
    };

    this.columnDef = [
      {
        field: 'unnr',
        headerName: 'UN',
      },
      {
        field: 'gewicht',
        headerName: 'Kg',
      },
      {
        field: 'klasse',
        headerName: 'Klasse',
      },
      {
        field: 'stoffbezeichnung',
        headerName: 'Stoffbezeichnung',
      },
      {
        field: 'nebengefahren',
        headerName: 'Nebengefahr',
      }
    ]
  }

  ngOnInit(): void {
  }

  gridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.dangerous_goods)
  }
}
